import React from 'react';

export interface CarIconProps {}

export const CarIcon: React.FC<CarIconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 18.5v-5.014c0-.357-.059-.702-.168-1.025l-1.403-5.33a2.56 2.56 0 0 0-2.195-1.893C14.79 5.079 14.045 5 12 5s-2.79.08-4.233.238A2.56 2.56 0 0 0 5.57 7.13l-1.403 5.33C4.06 12.784 4 13.13 4 13.486V18.5a.5.5 0 0 0 .5.5h2.11a.5.5 0 0 0 .485-.379L7.5 17h9l.405 1.621a.5.5 0 0 0 .486.379h2.11a.5.5 0 0 0 .5-.5zm-4.2-12c.624.09 1.173.53 1.337 1.154L18 10.7c-.318-.169-1.026-.326-1.401-.378C15.058 10.107 13.978 10 12 10c-1.979 0-3.056.107-4.597.322-.375.052-1.085.209-1.403.378l.862-3.046C7.026 7.029 7.576 6.59 8.2 6.5c1.404-.201 1.79-.232 3.8-.232 2.011 0 2.395.031 3.8.232zm1.7 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM8 13.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"
        fill="currentColor"
      ></path>
      <path
        d="M21.5 9a.5.5 0 0 1 .5.5v.408a1 1 0 0 1-.886.993l-.428.05a.5.5 0 0 1-.542-.376l-.238-.954A.5.5 0 0 1 20.39 9H21.5z"
        fill="currentColor"
      ></path>
      <path
        d="M2.5 9a.5.5 0 0 0-.5.5v.408a1 1 0 0 0 .886.993l.428.05a.5.5 0 0 0 .542-.376l.239-.954A.5.5 0 0 0 3.61 9H2.5z"
        fill="currentColor"
      ></path>
    </svg>
  );
};
